/**
 * Add notice component save, update and clone notice to database as well upload content images and hero image to s3 bucket.
 */

import React from "react";

import CKEditor from "ckeditor4-react";

import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import DatePicker from "react-datepicker";

import { config } from "../../../config/config";

import * as postsActions from "../../../store/admin";

import * as _ from "lodash";

import { NavLink } from "react-router-dom";

import { NotificationManager } from "react-notifications";

import "react-datepicker/dist/react-datepicker.css";

import "react-notifications/lib/notifications.css";

import { BackStrip, Header } from "../../../common/layout";

import { routes } from "../../../routes";

import { deviceDetect } from "react-device-detect";

import { utilPostService, utilService } from "../../../common/utils";

class AddNotice extends React.Component {
  constructor(props) {
    super(props);
    // bind events
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onFileUploadReq = this.onFileUploadReq.bind(this);
    this.onFileUploadRes = this.onFileUploadRes.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
    this.onFeaturedImgchange = this.onFeaturedImgchange.bind(this);
    this.onUserTypeChange = this.onUserTypeChange.bind(this);
    this.onGroupsChange = this.onGroupsChange.bind(this);
    // this.onFilterGroupInputSearch = this.onFilterGroupInputSearch.bind(this);
    this.handlePublishedRadiobox = this.handlePublishedRadiobox.bind(this);
    this.onFeatureImgError = this.onFeatureImgError.bind(this);
    // this.onSubmit = this.onSubmit.bind(this);
    this.onClonePost = this.onClonePost.bind(this);
    // init state
    this.state = {
      noticeData: {
        make_public: false,
        type: "notice",
        sort_order: "5",
        published: true,
        publish_start: new Date(),
        publish_end: new Date(),
        clone: false,
        for_carer_only: false,
        group_list: {
          userTypes: [
            { id: "1", value: "STUDENTS", isChecked: false },
            { id: "2", value: "CARERS", isChecked: false },
            { id: "3", value: "STAFF", isChecked: false },
          ],
          groups: [],
          groupNames: [],
        },
      },
      excerpt_change: false,
      input_group_search: "",
      sort_order_array: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      featuredImgFileObj: null,
      featuredImgUrl: "",
      featuredImgBase64Url: "",
      errors: {},
      isLoading: false,
      isSaving: false,
      isCloning: false,
      isClose: false,
    };
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // google analytic page view
    utilService.pageView();
    // console.log(this.props)
    // Get postUid from url and fetch that post

    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "add-notice",
      title: "Add Notice",
      browserName: browserName,
      osName: osName,
      pageType: "Add Notice Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    const id = this.props.match.params.id;
    if (id) {
      // fetch post based on postUid
      this.props.fetchPost({
        id: this.props.match.params.id,
        token: this.props.token,
      });
    }
    // Fetch groups
    this.props.fetchGroups(this.props.token);
    // this.props.fetchCategories(this.props.token)
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs in state and props
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps) {
    // After saving post redirect to admin home page
    if (this.state.isClose || this.state.isCloning) {
      if (prevProps.postActionLoading && !this.props.postActionLoading) {
        NotificationManager.success(
          "Success message",
          "Notice saved successfully."
        );
        this.props.history.push("/admin");
      }
    } else if (this.state.isSaving && !this.state.isClose) {
      if (prevProps.postActionLoading && !this.props.postActionLoading) {
        // Get current postUid after save post
        let currentPostUid = this.props.currentPostUid;

        const id = this.props.match.params.id;

        if (id) {
          this.props.fetchPost({
            id: currentPostUid,
            token: this.props.token,
          });

          this.setState(
            {
              errors: {},
              isLoading: false,
              isSaving: false,
              isCloning: false,
              isClose: false,
            },
            function () {
              NotificationManager.success(
                "Success message",
                "Notice saved successfully."
              );
            }
          );
        } else {
          this.props.history.push("/admin/edit-notice/" + currentPostUid);
          NotificationManager.success(
            "Success message",
            "Notice saved successfully."
          );
        }

        // Get current post after click on save button

        // console.log('CurrentPostUid...........', currentPostUid)
        // fields['postUid'] = currentPostUid;

        // fields = {};
        // fields['make_public'] = false;
        // fields['type'] = 'notice';
        // fields['sort_order'] = "5";
        // fields['published'] = true;
        // fields['publish_start'] = new Date()
        // fields['publish_end'] = new Date()
        // fields['clone'] = false
        // fields['group_list'] = {
        //   userTypes: [
        //     { id: "1", value: 'STUDENTS', isChecked: false },
        //     { id: "2", value: 'CARERS', isChecked: false },
        //     { id: "3", value: 'STAFF', isChecked: false }
        //   ],
        //   groups: [],
        //   groupNames: []
        // }
        // this.setState({
        //   ...this.state,
        //   noticeData: fields,
        //   excerpt_change: false,
        //   input_group_search: '',
        //   sort_order_array: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        //   featuredImgFileObj: null,
        //   featuredImgUrl: '',
        //   featuredImgBase64Url: '',
        //   errors: {},
        //   isLoading: false,
        //   isSaving: false,
        //   isCloning: false,
        //   isClose: false,
        // })
        // this.myFormRef.reset();
      }
    }
  }
  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('nex props...', nextProps)
    // console.log('this props...........', this.props)
    if (nextProps.post) {
      if (nextProps.post !== this.props.post) {
        // console.log('111')
        let postJson = nextProps.post;
        let image_url = postJson["featured_img_url"];
        postJson["featured_img_url"] = postJson["postUid"];
        if (postJson.published) {
          postJson.publish_start = new Date(postJson.publish_start);
          postJson.publish_end = new Date(postJson.publish_end);
        }
        this.setState({
          ...this.state,
          noticeData: postJson,
          featuredImgUrl: image_url,
          excerpt_change: postJson.excerpt ? true : false,
        });
      }
    }
  }

  /**
   * Set publish dates
   * @param {*} date
   * @param {*} name
   */
  handleDateChange(date, name) {
    // console.log(date)
    // console.log(this.state)
    let fields = this.state.noticeData;
    fields[name] = date;
    this.setState({
      fields,
    });
  }
  /**
   * Set true if post is published
   * @param {*} e
   */
  handlePublishedRadiobox(e) {
    const { name } = e.target;
    let fields = this.state.noticeData;
    fields["publish_start"] = null;
    fields["publish_end"] = null;
    if (e.target.value === "false") {
      fields[name] = false;
    } else {
      fields[name] = true;
    }
    this.setState({
      fields,
    });
  }

  /**
   * Set content of editor
   * @param {*} e
   */

  onEditorChange(e) {
    let fields = this.state.noticeData;
    let editor_text = e.editor.document.getBody().getText();
    fields["content_html"] = e.editor.getData();
    // const id = this.props.match.params.id;
    // if (id) {
    //   if (this.state.init_excertp) {
    //     fields['excerpt'] = editor_text ? editor_text.slice(0, 150) : '';
    //   }
    // } else {
    //   fields['excerpt'] = editor_text ? editor_text.slice(0, 150) : '';
    // }
    if (!this.state.excerpt_change) {
      fields["excerpt"] = editor_text ? editor_text.slice(0, 150) : "";
    }
    this.setState({
      fields,
    });
  }

  /**
   * Summary. Function used to find image tag and src attribute from content_html.
   * @param {*} str  content html string
   * @param {*} node tage (img)
   * @param {*} attr attriubte (src)
   */
  getAttrFromString(str, node, attr, style) {
    // let regex = new RegExp('<' + node + ' .*?' + attr + '="(.*?)" />', "gi"),
    //   result, res = [];
    let regex = new RegExp(
        "<" + node + " .*?" + attr + '="(.*?)" ' + style + '="(.*?)" />',
        "gi"
      ),
      result,
      res = [];
    while ((result = regex.exec(str))) {
      var obj = {};
      obj["tag"] = result[0];
      obj["key"] = result[1];
      obj["style"] = result[2];
      res.push(obj);
    }
    return res;
  }

  /**
   * Filter groups on search in input box
   * @param {*} group
   * @param {*} e
   */

  onFilterGroupInputSearch(group, e) {
    // console.log(group)
    e.preventDefault();
    const { value } = e.target;
    // console.log(name)
    // console.log(value)
    this.setState({
      input_group_search: {
        group: group,
        keyword: value,
      },
    });
  }
  /**
   * Handle input change event
   * @param {*} e
   */
  handleInputChange(e) {
    const { name, value } = e.target;
    // console.log(name, value)
    let fields = this.state.noticeData;
    let excerpt_change = this.state.excerpt_change;
    if (name === "excerpt" && value) {
      excerpt_change = true;
    } else if (name === "excerpt" && !value) {
      excerpt_change = false;
    }
    if (name === "for_carer_only") {
      fields[name] = e.target.checked;
    } else {
      fields[name] = value;
    }
    this.setState({
      fields,
      excerpt_change,
    });
  }

  /**
   * On clone post submit form data
   * @param {*} e Submit event
   */
  onClonePost(e) {
    e.preventDefault();
    if (this.validateForm()) {
      // Replace content_html's img tage src attribute to save uuid of editor images.
      let content_string = this.state.noticeData["content_html"];
      // let res = this.getAttrFromString(this.state.noticeData['content_html'], 'img', 'src');
      let res = this.getAttrFromString(
        this.state.noticeData["content_html"],
        "img",
        "src",
        "style"
      );
      if (res && res.length > 0) {
        res.map(async function (single) {
          let url = single.key;
          url = url.replace(config.url.media_bucket_url, "");
          url = url.split("?");
          // console.log(url);
          let key = url[0].split("/");
          content_string = content_string.replace(single.key, key[1]);
          // console.log(content_string);
        });
      }
      // add style and target attribute to anchor tage
      let regex = new RegExp('<a.*?href="(.*?)"(.*?)</a>', "gi");

      let result = [];

      while ((result = regex.exec(content_string))) {
        // console.log(result)
        if (result[0]) {
          let href_attribute = result[1];

          let content_first_part = content_string.substr(0, result["index"]);

          let str_second_part = content_string.substring(
            result["index"],
            regex.lastIndex
          );

          let content_second_part_list = str_second_part.split(" ");

          if (!result[0].includes('style="')) {
            // console.log('first............', content_string.substr(0, result['index']))

            // console.log('second...........', content_string.substring(result['index'], regex.lastIndex))

            content_second_part_list[0] =
              content_second_part_list[0] +
              ' style="color: #C41425;text-decoration: none;"';
          }

          // console.log(href_attribute)
          // let link = result[1] + ' style="color: #C41425;text-decoration: none;"'
          // check exteneral link or internal link
          let path_match = false;
          if (!result[0].includes('target="_blank"')) {
            routes.forEach((item, index) => {
              let path = item["path"];
              if (path !== "/" && path !== "/docusign" && path !== "/docusignboarder") {
                if (
                  href_attribute.includes(path) ||
                  href_attribute.includes("https://places.plc.sydney") ||
                  href_attribute.includes("http://devplaces.plc.sydney")
                ) {
                  path_match = true;
                }
              }
            });
            if (!path_match) {
              content_second_part_list[0] =
                content_second_part_list[0] + ' target="_blank"';
            }
          }

          let changed_string = content_second_part_list.join(" ");
          str_second_part = changed_string;

          // console.log("Changed String.............", changed_string);

          let content_third_part = content_string.substr(regex.lastIndex);

          // console.log('third.......', content_string.substr(regex.lastIndex))

          content_string =
            content_first_part + str_second_part + content_third_part;

          // console.log(content_string)

          // console.log('Result............', result[1])
          // console.log('link..............', link)

          // content_string = content_string.replace(result[1], link);
          // console.log(content_string)
          // debugger
        }
      }
      let fields = this.state.noticeData;
      fields["content_html"] = content_string;
      delete fields["postUid"];
      fields["clone"] = true;
      fields["created_at"] = new Date();
      fields["updated_at"] = new Date();
      fields["users_userid"] = this.props.user.userUid;
      fields["users_username"] = this.props.user.username;
      fields["users_firstname"] = this.props.user.firstname;
      fields["users_lastname"] = this.props.user.surname;
      this.setState(
        {
          fields,
          isLoading: true,
          isSaving: false,
          isCloning: true,
        },
        function () {
          // console.log(this.state.noticeData)
          this.props.createPost(this.props.token, this.state.noticeData);
        }
      );
    }
  }

  /**
   * Set contact type
   * @param {*} e
   */
  onUserTypeChange(e) {
    // console.log(e.target.value);
    // console.log(e.target.checked)
    let userTypes = this.state.noticeData.group_list.userTypes;
    userTypes.forEach((type) => {
      if (type.value === e.target.value) {
        type.isChecked = e.target.checked;
      }
    });
    this.setState({
      userTypes: userTypes,
    });
  }

  /**
   * On file input change of hero image,get file object and convert to base64 url.
   * @param {*} e File event
   */
  onFeaturedImgchange(e) {
    if (e.target.files[0]) {
      let fields = this.state.noticeData;
      let url = this.getBase64Image(e.target.files[0]);
      url.then((result) => {
        fields["featuredImage"] = result;
      });
      this.setState({
        fields,
        featuredImgUrl: URL.createObjectURL(e.target.files[0]),
        featuredImgFileObj: e.target.files[0],
      });
    }
  }

  /**
   * Summary. Function used to send server request to upload image.
   *
   * @param {*} e  ckeditor upload event
   */
  onFileUploadReq(e) {
    // console.log(e);
    let xhr = e.data.fileLoader.xhr;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Authorization", "Bearer " + this.props.token);
    xhr.send(
      JSON.stringify({ base64ImageUrl: e.data.fileLoader.data.split(",")[1] })
    );
    e.stop();
    e.cancel();
  }

  /**
   * Summary. Function used to get response of upload editor image from server.
   * @param {*} e upload response event
   */
  onFileUploadRes(e) {
    e.stop();
    // console.log(e.data);
    let data = e.data;
    let xhr = data.fileLoader.xhr;
    // console.log(xhr)
    let response = xhr.responseText.split("|");
    // console.log(response)
    if (response[1]) {
      // An error occurred during upload.
      data.message = response[1];
      e.cancel();
    } else {
      let parse_response = JSON.parse(response[0].toString());
      data.url = parse_response["responceObject"]["records"]["url"];
    }
  }

  onFeatureImgError(e) {
    this.setState({
      featuredImgUrl: "assets/img/no-image.png",
    });
  }

  /**
   * Set post groups
   * @param {*} e
   */
  onGroupsChange(e) {
    // console.log(e.target.value)
    let fields = this.state.noticeData;
    if (e.target.checked) {
      let gobj = _.find(this.props.groups, { groupUid: e.target.value });
      if (gobj) {
        fields["group_list"]["groups"].push(gobj);
        fields["group_list"]["groupNames"].push(gobj.groupname);
        this.setState({
          fields,
        });
      }
    } else {
      let gobj = _.find(fields.group_list.groups, { groupUid: e.target.value });
      if (gobj) {
        let grops = _.remove(fields.group_list.groups, function (o) {
          return o.groupUid === e.target.value;
        });
        _.remove(fields.group_list.groupNames, function (o) {
          return o === gobj.groupname;
        });
        this.setState({
          fields,
        });
      }
    }
  }
  /**
   * Convert file object to base64 image
   * @param {*} file
   */
  getBase64Image(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        // console.log(reader.result);
        resolve(reader.result.split(",")[1]);
        // return reader.result
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
        reject("");
      };
    });
  }

  /**
   * find group id in list of groups
   * @param {*} id
   */
  checkGroupId(id) {
    let obj = _.find(this.state.noticeData.group_list.groups, { groupUid: id });
    if (obj) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Validate form field before sumbmitting
   */
  validateForm() {
    let fields = this.state.noticeData;
    let errors = {};
    let formIsValid = true;

    if (!fields["title"]) {
      formIsValid = false;
      errors["title"] = "*Please enter title.";
    }
    if (!fields["content_html"]) {
      formIsValid = false;
      errors["content_html"] = "*Please enter content html.";
    }
    // if (!fields['postcategory_categoryid']) {
    //   formIsValid = false;
    //   errors['postcategory_categoryid'] = "*Please select category."
    // }
    if (!fields["sort_order"]) {
      formIsValid = false;
      errors["sort_order"] = "*Please select sort order.";
    }
    if (
      fields["published"] &&
      (!fields["publish_start"] || fields["publish_start"] === null)
    ) {
      formIsValid = false;
      errors["publish_start"] = "*Please select start date.";
    }
    if (
      fields["published"] &&
      fields["publish_end"] < fields["publish_start"]
    ) {
      formIsValid = false;
      errors["publish_end"] = "*Please select valid date.";
    }
    if (
      fields["published"] &&
      (!fields["publish_end"] || fields["publish_end"] === null)
    ) {
      formIsValid = false;
      errors["publish_end"] = "*Please select end date.";
    }
    if (!this.state.featuredImgUrl && !fields["featuredImage"]) {
      formIsValid = false;
      errors["featuredImage"] = "*Please select image.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  /**
   * Submit form data
   * @param {*} e
   */
  onSubmit(type, e) {
    e.preventDefault();
    if (this.validateForm()) {
      // console.log(this.props)

      // if (this.props.categories) {
      //   let fields = this.state.noticeData;
      //   let categories = this.props.categories;
      //   let catObj = _.find(categories, { 'postcategoryUid': this.state.noticeData.postcategory_categoryid })
      //   fields['postcategory_categoryname'] = catObj.categoryname;
      //   this.setState({
      //     fields
      //   })
      // }

      // Replace content_html's img tage src attribute to save uuid of editor images.
      let content_string = this.state.noticeData["content_html"];
      console.log("content-string", content_string);
      // let res = this.getAttrFromString(this.state.noticeData['content_html'], 'img', 'src');
      let res = this.getAttrFromString(
        this.state.noticeData["content_html"],
        "img",
        "src",
        "style"
      );
      if (res && res.length > 0) {
        res.map(async function (single) {
          let url = single.key;
          url = url.replace(config.url.media_bucket_url, "");
          url = url.split("?");
          console.log(url);
          let key = url[0].split("/");
          content_string = content_string.replace(single.key, key[1]);
          console.log(content_string);
        });
      }
      // add style attribute where added anchor tag in content html
      // let regex = new RegExp('<a.*?href="(.*?)"|.*?style="(.*?)"', "gi");
      let regex = new RegExp('<a.*?href="(.*?)"(.*?)</a>', "gi");

      let result = [];

      while ((result = regex.exec(content_string))) {
        // console.log(result)
        if (result[0]) {
          let href_attribute = result[1];

          let content_first_part = content_string.substr(0, result["index"]);

          let str_second_part = content_string.substring(
            result["index"],
            regex.lastIndex
          );

          let content_second_part_list = str_second_part.split(" ");

          if (!result[0].includes('style="')) {
            // console.log('first............', content_string.substr(0, result['index']))

            // console.log('second...........', content_string.substring(result['index'], regex.lastIndex))

            content_second_part_list[0] =
              content_second_part_list[0] +
              ' style="color: #C41425;text-decoration: none;"';
          }

          // console.log(href_attribute)
          // let link = result[1] + ' style="color: #C41425;text-decoration: none;"'
          // check exteneral link or internal link
          let path_match = false;
          if (!result[0].includes('target="_blank"')) {
            routes.forEach((item, index) => {
              let path = item["path"];
              if (path !== "/" && path !== "/docusign" && path !== "/docusignboarder") {
                if (
                  href_attribute.includes(path) ||
                  href_attribute.includes("https://places.plc.sydney") ||
                  href_attribute.includes("http://devplaces.plc.sydney")
                ) {
                  path_match = true;
                }
              }
            });
            if (!path_match) {
              content_second_part_list[0] =
                content_second_part_list[0] + ' target="_blank"';
            }
          }

          let changed_string = content_second_part_list.join(" ");
          str_second_part = changed_string;

          // console.log("Changed String.............", changed_string);

          let content_third_part = content_string.substr(regex.lastIndex);

          // console.log('third.......', content_string.substr(regex.lastIndex))

          content_string =
            content_first_part + str_second_part + content_third_part;

          // console.log(content_string)

          // console.log('Result............', result[1])
          // console.log('link..............', link)

          // content_string = content_string.replace(result[1], link);
          // console.log(content_string)
          // debugger
        }
      }
      let fields = this.state.noticeData;
      fields["content_html"] = content_string;
      // To search group names in dynamodb convert group names list to string
      if (
        fields["group_list"]["groupNames"] &&
        fields["group_list"]["groupNames"].length > 0
      ) {
        fields["group_list"]["groupNamesSearch"] = fields["group_list"][
          "groupNames"
        ].toString();
        fields["group_list"]["groupNamesSearch"] = fields["group_list"][
          "groupNamesSearch"
        ].toLowerCase();
      }
      this.setState({
        fields,
      });

      if (this.state.noticeData.postUid) {
        // console.log(this.state.noticeData)
        let fields = this.state.noticeData;
        fields["updated_at"] = new Date();
        fields["users_userid"] = this.props.user.userUid;
        fields["users_username"] = this.props.user.username;
        fields["users_firstname"] = this.props.user.firstname;
        fields["users_lastname"] = this.props.user.surname;
        this.setState({
          isLoading: true,
          isSaving: type === "close" ? false : true,
          isCloning: false,
          isClose: type === "close" ? true : false,
        });
        this.props.updatePost({
          token: this.props.token,
          data: this.state.noticeData,
        });
      } else {
        let fields = this.state.noticeData;
        fields["created_at"] = new Date();
        fields["updated_at"] = new Date();
        fields["users_userid"] = this.props.user.userUid;
        fields["users_username"] = this.props.user.username;
        fields["users_firstname"] = this.props.user.firstname;
        fields["users_lastname"] = this.props.user.surname;
        fields["daily_flag"] = false;
        this.setState({
          fields,
          isLoading: true,
          isSaving: type === "close" ? false : true,
          isCloning: false,
          isClose: type === "close" ? true : false,
        });
        // console.log(this.state.noticeData)
        this.props.createPost(this.props.token, this.state.noticeData);
      }
    }
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    const { groups, categories } = this.props;
    let grupBy = _.groupBy(groups, "grouptype");
    console.log(this.state);
    if (this.state.input_group_search) {
      // console.log(this.state.input_group_search)
      // console.log(grupBy[this.state.input_group_search.group])
      let keyword = this.state.input_group_search.keyword;
      if (keyword) {
        let filg = _.filter(
          grupBy[this.state.input_group_search.group],
          function (o) {
            // console.log(o.groupname)
            let match = o.groupname.match(new RegExp(keyword, "gi"));
            // console.log(match)
            return match && match.length > 0;
          }
        );
        // console.log(filg)
        grupBy[this.state.input_group_search.group] = filg;
      }
    }
    const groupBy = grupBy;
    // console.log(grupBy)
    const categoryByType = _.filter(categories, {
      categorytype: this.state.noticeData.type,
    });
    const notice_id = this.props.match.params.id;
    let selected_contact_types_string = "";
    if (
      this.state.noticeData.group_list.userTypes &&
      this.state.noticeData.group_list.userTypes.length > 0
    ) {
      // Get selected contact tpes from user types list
      selected_contact_types_string = utilPostService.getContactTypes(
        this.state.noticeData.group_list.userTypes
      );
    }
    return (
      <div>
        <BackStrip nav="/admin" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header cname="admin-home" text="Add Notice" />
            <main className="admin-home">
              <div className="container" style={{ maxWidth: "95%" }}>
                <form ref={(el) => (this.myFormRef = el)} name="addNotice">
                  <div className="row justify-content-end brd-btm">
                    <ul
                      className="nav nav-pills d-flex justify-content-center"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <NavLink className="nav-link active" to="/admin">
                          Admin Home
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#archived"
                        >
                          Email Logs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#archived"
                        >
                          Web Logs
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                    <h1>NOTICE</h1>
                  </div>
                  <div className="row">
                    <div className="col-md-4 bg-offlight reps-m-2">
                      <div className="radioslide">
                        {this.state.noticeData.group_list.userTypes.map(
                          (item, index) => (
                            <label key={item.id} className="typecheck">
                              {item.value}
                              <input
                                type="checkbox"
                                onChange={this.onUserTypeChange}
                                value={item.value}
                                checked={item.isChecked}
                              />
                              <span className="typemark"></span>
                            </label>
                          )
                        )}
                        <div className="accordion" id="accordionExample">
                          {groups &&
                            Object.keys(groupBy).map((item, index) => (
                              <div key={item} className="card">
                                <div className="card-header" id="headingOne">
                                  <a
                                    className="btn btn-link"
                                    data-toggle="collapse"
                                    data-target={`#group-type-${index}`}
                                    aria-expanded="false"
                                    aria-controls={item}
                                  >
                                    <h2 className="mb-0">{item}</h2>
                                  </a>
                                </div>
                                <div
                                  id={`group-type-${index}`}
                                  className="collapse"
                                  aria-labelledby="headingOne"
                                  data-parent="#accordionExample"
                                >
                                  <div className="card-body">
                                    <div className="filt d-flex justify-content-between align-items-center">
                                      <input
                                        type="text"
                                        name="inputfilter"
                                        onChange={this.onFilterGroupInputSearch.bind(
                                          this,
                                          item
                                        )}
                                      ></input>
                                      <i
                                        className="fa fa-filter"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    {groupBy &&
                                      groupBy[item].map((subitem, index) => (
                                        <label
                                          key={subitem.groupUid}
                                          className="typecheck"
                                        >
                                          {subitem.groupname}
                                          <input
                                            type="checkbox"
                                            checked={this.checkGroupId(
                                              subitem.groupUid
                                            )}
                                            onChange={this.onGroupsChange}
                                            value={subitem.groupUid}
                                          />
                                          <span className="typemark"></span>
                                        </label>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        <div>
                          <h2 className="selected-group-title">
                            Selected Groups
                          </h2>
                          <div className="selected-group">
                            {this.state.noticeData.group_list.groups &&
                              this.state.noticeData.group_list.groups.map(
                                (item, index) =>
                                  item.groupname +
                                  (this.state.noticeData.group_list.groups
                                    .length -
                                    1 !==
                                  index
                                    ? ","
                                    : "")
                              )}
                            {selected_contact_types_string
                              ? selected_contact_types_string
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="filters">
                        <p className="datetext">Types</p>
                        <div className="brd-1 pt-1">
                          <div className="row">
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Notice
                                <br />
                                <input
                                  type="radio"
                                  name="type"
                                  checked={
                                    this.state.noticeData.type === "notice"
                                  }
                                  onChange={this.handleInputChange}
                                  value="notice"
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Principal
                                <br />
                                <input
                                  type="radio"
                                  name="type"
                                  checked={
                                    this.state.noticeData.type === "principal"
                                  }
                                  onChange={this.handleInputChange}
                                  value="principal"
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Dailymail
                                <br />
                                <input
                                  type="radio"
                                  name="type"
                                  checked={
                                    this.state.noticeData.type === "dailyemail"
                                  }
                                  onChange={this.handleInputChange}
                                  value="dailyemail"
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="brd-1 pt-1">
                          <div className="row">
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Draft Mode
                                <br />
                                <span>(Will Not Send)</span>
                                <input
                                  type="radio"
                                  name="published"
                                  checked={
                                    this.state.noticeData.published === false
                                  }
                                  onChange={this.handlePublishedRadiobox}
                                  value={false}
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Post
                                <br />
                                <span>(Will Send)</span>
                                <input
                                  type="radio"
                                  name="published"
                                  onChange={this.handlePublishedRadiobox}
                                  checked={
                                    this.state.noticeData.published === true
                                  }
                                  value={true}
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                            <div className="col-md-6 col-lg-4 brdleft pb-2">
                              <div className="d-flex flex-column">
                                <label className="sort-label">Sort Order</label>
                                <select
                                  className="select_form"
                                  name="sort_order"
                                  onChange={this.handleInputChange}
                                  value={this.state.noticeData.sort_order || ""}
                                >
                                  <option value="">Select sort order</option>
                                  {this.state.sort_order_array.map(
                                    (item, index) => (
                                      <option key={index} value={item}>
                                        {item}
                                      </option>
                                    )
                                  )}
                                </select>
                                <div className="errorMsg">
                                  {this.state.errors["sort_order"]}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.noticeData.type !== "notice" && (
                          <div className="brd-1 pt-1">
                            <div className="row">
                              <div className="col-md-6 col-lg-6">
                                <label className="typecheck">
                                  EXCLUDE STUDENTS
                                  <input
                                    type="checkbox"
                                    name="for_carer_only"
                                    onChange={this.handleInputChange}
                                    checked={
                                      this.state.noticeData.for_carer_only ===
                                      true
                                    }
                                    value={this.state.noticeData.for_carer_only}
                                  />
                                  <span className="typemark"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        )}

                        {this.state.noticeData.published && (
                          <div className="brd-1 pt-1">
                            <div className="row pt-1">
                              <div className="col-lg-6">
                                <div className="date">
                                  <p className="datetext">Start Date</p>
                                  <DatePicker
                                    className="form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    selected={
                                      this.state.noticeData.publish_start
                                    }
                                    onChange={(date) =>
                                      this.handleDateChange(
                                        date,
                                        "publish_start"
                                      )
                                    }
                                  />
                                  <div className="errorMsg">
                                    {this.state.errors["publish_start"]}
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="date">
                                  <p className="datetext">End Date</p>
                                  <DatePicker
                                    className="form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    selected={this.state.noticeData.publish_end}
                                    onChange={(date) =>
                                      this.handleDateChange(date, "publish_end")
                                    }
                                  />
                                  <div className="errorMsg">
                                    {this.state.errors["publish_end"]}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="">
                          <div className="row">
                            <div className="col-lg-6 col-xl-7">
                              <div className="mt-2">
                                <label className="title-label">Title</label>
                                <input
                                  type="text"
                                  name="title"
                                  className="form-control"
                                  placeholder="Enter Title"
                                  onChange={this.handleInputChange}
                                  value={this.state.noticeData.title || ""}
                                />
                                <div className="errorMsg">
                                  {this.state.errors["title"]}
                                </div>
                              </div>
                              {/* <div className="mt-2">
                                <label className="title-label  d-block">Category</label>
                                <select className="select_form" name="postcategory_categoryid" onChange={this.handleInputChange} value={this.state.noticeData.postcategory_categoryid || ''}>
                                  <option value="">Select category</option>
                                  {
                                    categoryByType && categoryByType.map((item, index) => (
                                      <option key={item.postcategoryUid} value={item.postcategoryUid}>{item.categoryname}</option>
                                    ))
                                  }
                                </select>
                                <div className="errorMsg">{this.state.errors['postcategory_categoryid']}</div>
                              </div> */}
                            </div>
                            <div className="col-lg-6 col-xl-4">
                              {this.state.featuredImgUrl && (
                                <div className="priview">
                                  <img
                                    src={this.state.featuredImgUrl}
                                    width="150px"
                                    height="110px"
                                    alt="Preview"
                                    className=""
                                  ></img>
                                </div>
                              )}
                              <div className="d-flex align-items-center">
                                <input
                                  type="file"
                                  id="myFile"
                                  className="custom-file-input input-file"
                                  onChange={this.onFeaturedImgchange}
                                />
                                <p>
                                  Thumbnail
                                  <br /> (150*110)
                                </p>
                              </div>
                              <div className="errorMsg">
                                {this.state.errors["featuredImage"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-10 pt-1">
                            <label className="title-label  d-block">
                              Content
                            </label>
                            <CKEditor
                              onBeforeLoad={(CKEDITOR) => (
                                (CKEDITOR.disableAutoInline = true),
                                CKEDITOR.addCss(
                                  'body.cke_editable { font-family: "Open Sans";font-size: 16px;line-height: 1.6;color: #586667;background-color: #ffffff;}p {color: #000;font-family: "Open Sans";font-size: 16px;}a {color: #C41425;text-decoration: none;}h1, h2, h3, h4, h5, h6, li  {color: #000}'
                                )
                              )}
                              config={{
                                versionCheck: false,
                                stylesSet: [
                                  // Block-level styles.
                                  {
                                    name: "Content title",
                                    element: "h1",
                                    styles: {
                                      color: "#C41425",
                                      "font-family": "Open Sans Semibold",
                                      "line-height": "135%",
                                    },
                                  },
                                  {
                                    name: "Content Info",
                                    element: "p",
                                    styles: {
                                      color: "#586667",
                                      padding: "0px !important",
                                      "font-family": "Open Sans Light",
                                      "font-size": "14px",
                                    },
                                  },
                                  // Inline styles.
                                  {
                                    name: "Text Gray",
                                    element: "p",
                                    styles: {
                                      color: "#AAA !important",
                                      "font-family": "Open Sans Light",
                                      "font-size": "16px",
                                    },
                                  },
                                  {
                                    name: "Anchor Red",
                                    element: "a",
                                    styles: {
                                      color: "#C41425 !important",
                                      "text-decoration": "none",
                                    },
                                  },
                                ],
                                format_tags:
                                  "p;h1;h2;h3;h4;h5;h6;pre;address;div",
                                // extraPlugins: 'embed,autoembed,image2',
                                extraPlugins: "embed,autoembed",
                                // filebrowserBrowseUrl: '/browser/browse.php',
                                filebrowserUploadUrl:
                                  config.api_url +
                                  config.url.upload_editor_image,
                                embed_provider:
                                  "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
                              }}
                              onFileUploadRequest={this.onFileUploadReq}
                              onFileUploadResponse={this.onFileUploadRes}
                              onChange={this.onEditorChange}
                              data={this.state.noticeData.content_html || ""}
                            />
                            <div className="errorMsg">
                              {this.state.errors["content_html"]}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-10 pt-1">
                            <div className="d-block">
                              <label className="title-label">Excerpt</label>
                              <textarea
                                name="excerpt"
                                rows="8"
                                onChange={this.handleInputChange}
                                value={this.state.noticeData.excerpt || ""}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end pt-3">
                    {!this.state.isClose && (
                      <button
                        className="bg-primary filter-btn"
                        onClick={this.onSubmit.bind(this, "close")}
                      >
                        save & close
                      </button>
                    )}
                    {this.state.isClose && (
                      <button
                        className="bg-primary filter-btn"
                        disabled={this.state.isLoading}
                      >
                        save & close ...
                      </button>
                    )}
                    <a href="#">
                      {this.state.isSaving && (
                        <button
                          disabled={this.state.isLoading}
                          className="bg-primary filter-btn"
                        >
                          save ....
                        </button>
                      )}
                      {!this.state.isSaving && (
                        <button
                          className="bg-primary filter-btn"
                          onClick={this.onSubmit.bind(this, "open")}
                        >
                          save
                        </button>
                      )}
                    </a>
                    {notice_id && this.state.isCloning && (
                      <a href="#">
                        <button
                          onClick={this.onClonePost}
                          className="bg-primary filter-btn"
                          disabled={this.state.isLoading}
                        >
                          clone ...
                        </button>
                      </a>
                    )}
                    {notice_id && !this.state.isCloning && (
                      <a href="#">
                        <button
                          onClick={this.onClonePost}
                          className="bg-primary filter-btn"
                        >
                          clone
                        </button>
                      </a>
                    )}
                    <NavLink to="/admin">
                      <button className="bg-dark filter-btn">cancel</button>
                    </NavLink>
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  console.log("state....", state);
  // console.log('props.', props)
  const id = props.match.params.id;
  return {
    postActionLoading: state.posts.actionsloading,
    post: id
      ? state.posts.byId[id]
      : state.posts.currentPostUid
      ? state.posts.byId[state.posts.currentPostUid]
      : "",
    token: state.user.cognito_data.token,
    user: state.user.user,
    groups: Object.values(state.groups.byId),
    currentPostUid: state.posts.currentPostUid,
    // categories: Object.values(state.category.byId)
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(postsActions, dispatch)
)(AddNotice);
